import { useParams } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import PageHeader from "../../components/PageHeader";
import SubButton from "../../components/SubButtons";
import StudentsInTheGroup from "./StudentsInTheGroup";
import { useEffect, useState } from "react";
import GroupApis from "../../api/groupApis";
import { toast } from "sonner";
import { GroupStaff } from "../../types/groupAndHouses";

export default function ViewGroupDetails() {
  const { groupId } = useParams<{ groupId: string }>();

  const [groupData, setGroupData] = useState<{
    groupName: string;
    staffs: GroupStaff[];
  }>({
    groupName: "",
    staffs: [],
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!groupId) return;

    const fetchGroup = async () => {
      try {
        setLoading(true);
        const data = await GroupApis.getGroupById(Number(groupId));

        if (data) {
          setGroupData({
            groupName: data.groupName,
            staffs: data.staffs || [],
          });
        }
      } catch (error) {
        toast.error("Failed to load group details");
      } finally {
        setLoading(false);
      }
    };

    fetchGroup();
  }, [groupId]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // setGroupData(e.target.value);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <PageHeader showBack />
        {/* <CustomButton text="Edit" color="bg-warning-600" /> */}
      </div>
      <div className="flex flex-col gap-2">
        <div className="bg-white px-6 py-5 rounded-lg flex flex-col gap-9">
          <CustomInput
            name="groupName"
            label="Group/House Name"
            type="text"
            placeholder="Enter the name of the group or house"
            value={groupData.groupName}
            onChange={handleInputChange}
            inputClassName="md:w-[50%]"
            readOnly
          />
          <div className="flex justify-between items-center max-w-3xl">
            <div className="flex gap-4 items-center">
              <span className="text-neutral-400 text-sm font-semibold">
                Teachers
              </span>
              <div className="flex gap-2 flex-wrap">
                {groupData.staffs.length > 0 ? (
                  groupData.staffs.map((staff) => (
                    <SubButton
                      key={staff.staffId}
                      text={staff.staffName}
                      color="bg-success-700"
                      padding="px-4"
                    />
                  ))
                ) : (
                  <SubButton
                    text="No Staff"
                    color="bg-neutral-400"
                    padding="px-4"
                  />
                )}
              </div>
            </div>
            <div className="flex gap-4 items-center">
              <span className="text-neutral-400 text-sm font-semibold">
                Teacher’s Designation
              </span>
              <SubButton padding="px-4" text="----" color="bg-success-700" />
            </div>
          </div>
        </div>
        <StudentsInTheGroup />
      </div>
    </div>
  );
}
